<template>
  <div>

  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
  created() {

    // window.addEventListener('keyup', event => {
    //   if (event.key === "/") {
    //   }
    // });
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Spesiyal/KisaYol.vue